"use client";

import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { ScrollableFlowScreen } from "../UI/ScrollableFlowScreen";
import { StepListDemo } from "../Demos/DeepActionFlow/InteractionDemos/StepListDemo";
import Image from "next/image";

interface StepListSectionProps {
  onDownloadClick?: () => void;
}

export function StepListSection({ onDownloadClick }: StepListSectionProps) {
  const stepRef = useRef<HTMLDivElement>(null);

  // Use the demo container ref for text scroll progress to ensure perfect sync
  const { scrollYProgress } = useScroll({
    target: stepRef,
    offset: ["start center", "end end"],
  });

  const stepTexts = [
    "Fellou analyzes your goal to create a detailed, step-by-step action plan at first. You can review, approve and edit this plan before execution.",
  ];

  // 第二阶段"Still typing..." 文本显示 (0.7-1.0, 占总进度30%)
  const stillTextOpacity = useTransform(scrollYProgress, [0.7, 0.75, 0.9, 1.0], [0, 1, 1, 1]);

  return (
    <div>
      <ScrollableFlowScreen ref={stepRef} onViewportEnter={() => console.log("Step List entered")} compact={true}>
        <div className="flex min-h-[400vh]">
          {/* Left Half - Progressive Text Display */}
          <div className="w-1/2 flex justify-center items-center px-8 sticky top-0 h-screen">
            <motion.div className="max-w-[600px] space-y-12">
              <h2 className="text-4xl font-bold text-white mb-8">From Intent to Action Plan</h2>
              {stepTexts.map((text, index) => (
                <div key={index} className="text-2xl font-medium text-white leading-relaxed">
                  {text}
                </div>
              ))}

              {/* Still Text - 第二阶段文本显示 (0.5-1.0) */}
              <motion.div className="space-y-8" style={{ opacity: stillTextOpacity }}>
                <div className="text-3xl font-bold text-white/90 leading-tight">
                  <div className="flex items-center gap-2 mb-4">Still typing long prompts?</div>
                  <div className="flex items-center gap-2">
                    <div className="relative flex-shrink-0 size-8">
                      <Image
                        src="/favicon.ico"
                        alt="fellou"
                        fill
                        priority
                        unoptimized
                        className="rounded p-0.5 ring-1 ring-white/20"
                      />
                    </div>
                    <div>Fellou plans first, acts second.</div>
                  </div>
                </div>
              </motion.div>
            </motion.div>
          </div>

          {/* Right Half - Step List Demo (Sticky) */}
          <div className="w-1/2 flex justify-center items-center px-8 sticky top-0 h-screen">
            <StepListDemo stepRef={stepRef} onDownloadClick={onDownloadClick} />
          </div>
        </div>
      </ScrollableFlowScreen>
    </div>
  );
}
